import React, { useEffect, useState } from 'react'
import { Modal, TimePicker } from 'antd'
import moment, { Moment } from 'moment'
import closeIcon from 'assets/Images/close.svg'
import ButtonSpinner from 'components/global/ButtonSpinner'
import { infoMessage } from 'api/global'
import { calculateTimeDiffernce } from 'helper/utility'
import { CellClickEventArgs } from '@syncfusion/ej2-react-schedule'

// Reuse the exact same modal styling as Events Step2
import 'pages/Events/Views/CreateEvent/Screens/Step2/Modals/styles/styles.scss'

type EventArgs = Partial<CellClickEventArgs> & {
  StartTime?: Date
  EndTime?: Date
  startTime?: Date
  endTime?: Date
  Id?: string
  eventActivityId?: string
}

export type TemplateTimeRange = {
  start: Moment
  end: Moment
}

interface TemplateEditTimeProps {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  defaultData?: EventArgs
  onSave: (range: TemplateTimeRange, eventId: string) => void
  loading?: boolean
}

const TemplateEditTime: React.FC<TemplateEditTimeProps> = ({
  openModal,
  setOpenModal,
  defaultData,
  onSave,
  loading,
}) => {
  const [start, setStart] = useState<Moment | null>(null)
  const [end, setEnd] = useState<Moment | null>(null)

  const handleCancel = () => setOpenModal(false)

  const handleSubmit = () => {
    if (!start || !end) return infoMessage('Start and end time is required')
    if (calculateTimeDiffernce(start.format('h:mm a'), end.format('h:mm a'), 'minutes') < 15) {
      return infoMessage(
        'Difference between start and end-time atleast should be 15 minutes',
      )
    }
    if (defaultData?.Id) {
      onSave({ start, end }, defaultData.Id)
    }
  }

  useEffect(() => {
    const s = defaultData?.StartTime || defaultData?.startTime
    const e = defaultData?.EndTime || defaultData?.endTime
    setStart(s ? moment(s) : moment().startOf('hour'))
    setEnd(e ? moment(e) : moment().startOf('hour').add(1, 'hour'))
  }, [defaultData])

  return (
    <Modal open={openModal} onCancel={handleCancel} className="checkout-model" footer={false}>
      <div className="flex-center pt-20px justify-between ">
        <h2 className="w-600 text-18">Edit activity time</h2>
        <img
          src={closeIcon}
          alt="close-button"
          onClick={handleCancel}
          className="close button pointer"
        />
      </div>
      <div className="mt-30px text-center activity-time">
        <div className={`time-picker flex mt-30`}>
          <div className="start-time" style={{ width: '50%' }}>
            <h3 className="text-start w-500 text-14">Start Time</h3>
            <TimePicker
              format="h:mm a"
              className="mt-10 w-100 form-control-field"
              value={start ?? undefined}
              use12Hours={true}
              minuteStep={15}
              onChange={t => setStart(t)}
            />
          </div>
          <div className="end-time ml-20" style={{ width: '50%' }}>
            <h3 className="text-start w-500 text-14">End Time</h3>
            <TimePicker
              format="h:mm a"
              className="mt-10 w-100 form-control-field"
              value={end ?? undefined}
              use12Hours={true}
              minuteStep={15}
              onChange={t => setEnd(t)}
            />
          </div>
        </div>
      </div>

      <div className="mt-30px flex gap-20px justify-center">
        <button className="form-btn-secondary  pointer " onClick={handleCancel}>
          Cancel
        </button>
        <button className="form-btn pointer" onClick={handleSubmit} disabled={!!loading}>
          {loading ? <ButtonSpinner size={20} color="#000" /> : 'Update'}
        </button>
      </div>
    </Modal>
  )
}

export default TemplateEditTime
